import memoize from 'memoize-one';
import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getMessageFromError } from 'my-core/error-utils';
import { onlineCourseCheckoutStepViewed, onlineCoursePurchased } from 'my-core/gtm-events';
import { insertScript, loadedScripts } from 'my-core/script-utils';
import { getCurrentUser } from 'my-core/storeUtils';

import OnlineCoursePurchaseForm from './OnlineCoursePurchaseForm';

import * as appStateActions from 'my-actions/AppStateActions';
import * as messageActions from 'my-actions/MessageActions';
import * as onlineCourseUserActions from 'my-actions/OnlineCourseUserActions';

const paypalScriptUrl = 'https://www.paypalobjects.com/api/checkout.js';

class OnlineCoursePurchaseFormCtnr extends Component {
  state = {
    activeStep: 0,
    packageType: 'pro',
    paypalLoaded: Boolean(loadedScripts[paypalScriptUrl]),
    purchasing: false,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const { defaultPackageType, purchaseStatus } = nextProps;
    if (prevState.purchasing && purchaseStatus !== prevState.prevPurchaseStatus) {
      return {
        purchasing: false,
        prevPurchaseStatus: null,
        ...(purchaseStatus.success ? { activeStep: 2 } : { activeStep: 0, purchaseError: purchaseStatus.error }),
      };
    }
    if (defaultPackageType !== prevState.prevDefaultPackageType) {
      return {
        prevDefaultPackageType: defaultPackageType,
        packageType: defaultPackageType || 'pro',
      };
    }
    return null;
  }

  componentDidMount() {
    this.checkoutEcommerce();
    insertScript(paypalScriptUrl, {
      onError: () => console.error('Paypal could not be loaded'),
      onLoad: () => this.setState({ paypalLoaded: true }),
    });
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.purchasing && !this.state.purchasing) {
      const { messageActions, onlineCourse, onlineCourseUser, purchaseStatus } = this.props;
      if (!purchaseStatus.success) {
        messageActions.addMessage({ content: getMessageFromError(purchaseStatus.error), type: 'error' });
      } else {
        // if (this.purchaseData.paymentDetails.total)
        onlineCoursePurchased(onlineCourse, onlineCourseUser, this.purchaseData);
      }
    }
    if (prevState.activeStep !== this.state.activeStep || prevState.packageType !== this.state.packageType) {
      this.checkoutEcommerce();
    }
  }

  checkoutEcommerce() {
    const { course, onlineCourse, open } = this.props;
    const { activeStep, packageType } = this.state;
    if (!open || activeStep === 2) return;
    // if (activeStep === 2) return;
    onlineCourseCheckoutStepViewed({ ...onlineCourse, course }, activeStep + 1, packageType);
  }

  submitPurchase = (params, purchaseData) => {
    const { onlineCourse, onlineCourseUserActions, purchaseStatus } = this.props;
    const { packageType } = this.state;
    this.purchaseData = purchaseData;
    onlineCourseUserActions.purchaseOnlineCourseUser(onlineCourse.id, { ...params, package_type: packageType });
    this.setState({ purchasing: true, prevPurchaseStatus: purchaseStatus });
  };

  showTermsAndConditions = () => {
    this.props.appStateActions.toggleTermsAndConditions(true);
  };

  changeStep = activeStep => this.setState({ activeStep });
  changePackageType = packageType => this.setState({ packageType });

  render() {
    const { course, currentUser, onClose, onlineCourse, onlineCourseUser, open = false } = this.props;
    const { activeStep, packageType, paypalLoaded, purchasing } = this.state;

    return (
      <OnlineCoursePurchaseForm
        activeStep={activeStep}
        course={course}
        currentUser={currentUser}
        onChangePackageType={this.changePackageType}
        onChangeStep={this.changeStep}
        onClose={onClose}
        onlineCourse={onlineCourse}
        onlineCourseUser={onlineCourseUser}
        onPurchase={this.submitPurchase}
        onShowTerms={this.showTermsAndConditions}
        open={open}
        packageType={packageType}
        paypalLoaded={paypalLoaded}
        purchasing={purchasing}
      />
    );
  }
}

const getOnlineCourseUser = memoize((uid, ocId, onlineCourseUsers) =>
  Object.values(onlineCourseUsers).find(ocu => ocu.user_id === uid && ocu.online_course_id === ocId),
);

export default connect(
  (state, { onlineCourseId }) => {
    const currentUser = getCurrentUser(state);
    const onlineCourse = state.onlineCourses.items[onlineCourseId];
    return {
      currentUser,
      onlineCourse,
      onlineCourseUser: getOnlineCourseUser(currentUser.id, onlineCourseId, state.onlineCourseUsers.items),
      course: state.courses.items[onlineCourse?.course_id],
      purchaseStatus: state.onlineCourseUsers.status.purchase,
    };
  },
  dispatch => ({
    appStateActions: bindActionCreators(appStateActions, dispatch),
    onlineCourseUserActions: bindActionCreators(onlineCourseUserActions, dispatch),
    messageActions: bindActionCreators(messageActions, dispatch),
  }),
)(OnlineCoursePurchaseFormCtnr);
